<template>
  <div class="condition-set-box mr-b10 advanced-input">
    <el-form :inline="true" ref="form" :rules="formDataRules" :model="formData" label-position="top" label-width="90px" @submit.native.prevent="checkEnter">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div v-if="tabName === 'icmp'">
          <el-row>
            <el-form-item prop="scanStart" label="시작 IP">
              <el-input v-model="formData.scanStart"></el-input>
            </el-form-item>
            <el-form-item prop="scanEnd" label="종료 IP">
              <el-input v-model="formData.scanEnd"></el-input>
            </el-form-item>
            <el-form-item prop="packetSize" label="패킷 크기" style="width:80px">
              <el-input v-model.number="formData.packetSize"></el-input>
            </el-form-item>
            <el-form-item prop="retryCount" label="재시도 횟수" style="width:80px">
              <el-input v-model.number="formData.retryCount"></el-input>
            </el-form-item>
            <el-form-item prop="timeout" label="타임 아웃(초)" style="width:80px">
              <el-input v-model="formData.timeout"></el-input>
            </el-form-item>
          </el-row>
        </div>
        <div v-else-if="tabName === 'snmp'">
          <el-row>
            <el-form-item prop="scanStart" label="시작 IP">
              <el-input v-model="formData.scanStart"></el-input>
            </el-form-item>
            <el-form-item prop="scanEnd" label="종료 IP">
              <el-input v-model="formData.scanEnd"></el-input>
            </el-form-item>
            <el-form-item prop="portStart" label="포트 번호" style="width:90px" :show-message="false">
              <el-input v-model.number="formData.portStart"></el-input>
            </el-form-item>
            <el-form-item prop="snmpVersion" label="SNMP 버전" style="width:90px" :rules="{ required: true }">
              <el-select v-model="formData.snmpVersion">
                <el-option v-for="item in snmpVersionList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-button @click="showSnmpVersionSetting = !showSnmpVersionSetting" style="margin-top:29px;margin-right:10px;margin-left:-11px">
              <i class="fas fa-cog"></i>
            </el-button> -->
            <el-form-item prop="retryCount" label="재시도 횟수" style="width:80px">
              <el-input v-model.number="formData.retryCount"></el-input>
            </el-form-item>
            <el-form-item prop="timeout" label="타임 아웃(초)" style="width:80px">
              <el-input v-model.number="formData.timeout"></el-input>
            </el-form-item>
          </el-row>
          <el-row v-if="formData.snmpVersion !== 'V3' && showSnmpVersionSetting">
            <el-form-item v-if="formData.snmpVersion != 'V3'" prop="community" label="Community" :show-message="false" :rules="{ required: true }">
              <el-input type="password" v-model="formData.community"></el-input>
            </el-form-item>
          </el-row>
          <el-row v-if="formData.snmpVersion === 'V3' && showSnmpVersionSetting">
            <el-form-item prop="snmpV3Username" label="User Name" :rules="{ required: true }" :show-message="false">
              <el-input v-model="formData.snmpV3Username"></el-input>
            </el-form-item>
            <el-form-item prop="snmpV3ContextId" label="Context" :show-message="false">
              <el-input v-model="formData.snmpV3ContextId"></el-input>
            </el-form-item>
            <el-form-item prop="snmpV3AuthProtocol" label="Auth" style="width:90px" :rules="{ required: true }" :show-message="false">
              <el-select v-model="formData.snmpV3AuthProtocol">
                <el-option v-for="item in snmpAuthList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="formData.snmpV3AuthProtocol !== 'NONE'" prop="snmpV3AuthPassword" label="비밀번호" style="margin-left:-11px" :rules="{ required: true }" :show-message="false">
              <el-input type="password" v-model="formData.snmpV3AuthPassword"></el-input>
            </el-form-item>
            <el-form-item prop="snmpV3PrivProtocol" label="Privacy" style="width:90px" :rules="{ required: true }" :show-message="false">
              <el-select v-model="formData.snmpV3PrivProtocol">
                <el-option v-for="item in snmpPrivList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="formData.snmpV3PrivProtocol !== 'NONE'" prop="snmpV3PrivPassword" label="비밀번호" style="margin-left:-12px" :rules="{ required: true }" :show-message="false">
              <el-input type="password" v-model="formData.snmpV3PrivPassword"></el-input>
            </el-form-item>
          </el-row>
        </div>
        <div v-else-if="tabName === 'tcp' || tabName === 'udp'">
          <el-row>
            <el-form-item prop="scanType" label="검색 방법" style="width:90px">
              <el-select v-model="formData.scanType">
                <el-option v-for="item in scanTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="scanStart" :label="formData.scanType === 'RANGE' ? '시작 IP' : 'IP 주소'">
              <el-input v-model="formData.scanStart"></el-input>
            </el-form-item>
            <el-form-item v-if="formData.scanType === 'RANGE'" prop="scanEnd" label="종료 IP">
              <el-input v-model="formData.scanEnd"></el-input>
            </el-form-item>
            <el-form-item prop="portStart" style="width:90px" :show-message="false">
              <label slot="label">
                {{ formData.scanType === 'SPOT' ? '시작 포트' : '포트 번호' }}
                <el-popover placement="right-end" trigger="click" width="360" :offset="4000" @show="clickWellKnownPortButton">
                  <div>
                    <el-row class="title-bar">
                      <div class="title-h4">Well-Known port</div>
                    </el-row>
                    <el-table-wrapper max-height="400" :data="wellKnownPortTableData" :columns="wellKnownPortColumns" :pagination="false"></el-table-wrapper>
                  </div>
                  <span slot="reference"><i class="fas fa-question-circle" style="cursor: pointer"></i></span>
                </el-popover>
              </label>
              <el-input v-model.number="formData.portStart"></el-input>
            </el-form-item>
            <el-form-item v-if="formData.scanType === 'SPOT'" prop="portEnd" label="종료 포트" style="width:90px" :show-message="false">
              <el-input v-model.number="formData.portEnd"></el-input>
            </el-form-item>
            <el-form-item prop="timeout" label="타임 아웃(초)" style="width:80px">
              <el-input v-model.number="formData.timeout"></el-input>
            </el-form-item>
          </el-row>
        </div>
        <div v-else-if="tabName === 'traceroute'">
          <el-row>
            <el-form-item prop="scanStart" label="IP 주소">
              <el-input v-model="formData.scanStart"></el-input>
            </el-form-item>
          </el-row>
        </div>
        <div>
          <el-button type="primary" :disabled="isLoading" size="x-large" @click="executeScan" style="position:absolute;top:0px;right:0px">스캔</el-button>
        </div>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { isNil, isEqual, cloneDeep, sortBy, assign, forEach, has } from 'lodash';
import { validateIpv4, validateInteger } from '@/utils/string';
import MsgUtil from '@/utils/message';
import { wellKnownPortColumns, wellKnownPortTcpData, wellKnownPortUdpData } from '@/constants/port';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import IpScanAPI from '@/api/ip-scan';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';

export default {
  name: 'WScanConditionBox',
  props: {
    tabInfo: {
      type: Object,
      default: () => {},
    },
    agentManagerId: {
      type: Number,
      default: 0,
    },
    defaultPort: {
      type: Number,
    },
    objInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    tabName() {
      return this.tabInfo.name;
    },
    active() {
      return this.tabInfo.active;
    },
  },
  data() {
    return {
      isLoading: false,
      showSnmpVersionSetting: true,
      wellKnownPortColumns,
      wellKnownPortTcpData,
      wellKnownPortUdpData,
      formDataRules: {
        scanType: {
          required: true,
          trigger: 'blur',
        },
        scanStart: {
          required: true,
          trigger: 'blur',
          validator: this.validateIpaddress,
        },
        scanEnd: {
          required: true,
          trigger: 'blur',
          validator: this.validateIpaddress,
        },
        portStart: {
          required: true,
          trigger: 'blur',
          validator: this.validatePort,
        },
        portEnd: {
          required: true,
          trigger: 'blur',
          validator: this.validatePort,
        },
      },
      formData: {
        scanType: 'SPOT',
        scanStart: null,
        scanEnd: null,
        packetSize: 16,
        retryCount: 0,
        timeout: 5,
        portStart: this.defaultPort,
        portEnd: '',
        snmpVersion: 'V1/V2',
        community: '',
        snmpV3Username: '',
        snmpV3ContextId: '',
        snmpV3AuthProtocol: 'NONE',
        snmpV3AuthPassword: '',
        snmpV3PrivProtocol: 'NONE',
        snmpV3PrivPassword: '',
        ipaddressApplytype: 'IPv4',
      },
      scanTypeList: [
        {
          id: 'SPOT',
          name: '단일',
        },
        {
          id: 'RANGE',
          name: '범위',
        },
      ],
      snmpVersionList: [],
      snmpAuthList: [],
      snmpPrivList: [],
      wellKnownPortTableData: [],
    };
  },
  watch: {
    objInfo: {
      handler(to) {
        if (!isNil(to)) {
          const objInfo = cloneDeep(to);
          objInfo.scanStart = objInfo.ipaddressIpv4;
          objInfo.community = objInfo.snmpCommunityRead;
          if (this.tabName === 'snmp') {
            objInfo.portStart = objInfo.snmpPort;
          }
          Object.assign(this.formData, objInfo);
        }
      },
    },
    'formData.scanType': {
      handler(to) {
        this.$emit('change-scan-type', to);
      },
    },
    'formData.scanStart': {
      handler(to) {
        this.formData.scanEnd = cloneDeep(to);
        this.$refs.form.validateField('scanStart');
        this.$refs.form.validateField('scanEnd');
      },
    },
    'formData.portStart': {
      handler(to, from) {
        this.setMinMaxData('portStart', to, from, 1, 65535);
        this.formData.portEnd = cloneDeep(to);
        this.$refs.form.validateField('portStart');
        this.$refs.form.validateField('portEnd');
      },
    },
    'formData.portEnd': {
      handler(to, from) {
        this.setMinMaxData('portEnd', to, from, 1, 65535);
      },
    },
    'formData.retryCount': {
      handler(to, from) {
        this.setMinMaxData('retryCount', to, from, 0, 3);
      },
    },
    'formData.timeout': {
      handler(to, from) {
        this.setMinMaxData('timeout', to, from, 0, 60);
      },
    },
    'formData.packetSize': {
      handler(to, from) {
        this.setMinMaxData('packetSize', to, from, 0, 2068);
      },
    },
  },
  mounted() {
    if (isEqual(this.tabName, 'snmp')) {
      this.loadSnmpInfo();
    }
  },
  methods: {
    loadSnmpInfo() {
      BasicinfoSubAPI.getList('SNMPVER').then((response) => {
        const result = response.data;
        if (result.success) {
          const resultData = result.data.filter((item) => !isEqual(item.basicinfoSubid, 'NONE'));
          this.snmpVersionList = cloneDeep(resultData);
        }
      });
      BasicinfoSubAPI.getList('SNMPAUTH').then((response) => {
        const result = response.data;
        if (result.success) {
          const resultData = result.data;
          this.snmpAuthList = cloneDeep(resultData);
        }
      });
      BasicinfoSubAPI.getList('SNMPPRIV').then((response) => {
        const result = response.data;
        if (result.success) {
          const resultData = result.data;
          this.snmpPrivList = cloneDeep(resultData);
        }
      });
    },
    clickWellKnownPortButton() {
      if (isEqual(this.tabName, 'tcp')) {
        this.wellKnownPortTableData = this.wellKnownPortTcpData;
      } else {
        this.wellKnownPortTableData = this.wellKnownPortUdpData;
      }
    },
    executeScan() {
      this.$refs.form
        .validate()
        .then(() => {
          IpScanAPI.getAgentStatusInfo(this.agentManagerId)
            .then((response) => {
              const result = response.data;
              if (result.success) {
                const agentStatus = result.data.agentStatus;
                const diffTime = result.data.diffTime;
                if (isEqual(agentStatus, '1')) {
                  this.loadScanResultData();
                } else {
                  this.$emit('set-table-data', this.tabName === 'traceroute' ? null : []);
                }
                this.$emit('set-agent-status-info', agentStatus, diffTime);
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    loadScanResultData() {
      this.isLoading = true;
      this.$emit('change-is-loading', true);
      const params = cloneDeep(this.formData);
      params.agentManagerId = this.agentManagerId;
      params.tabName = this.tabName;
      params.timeout *= 1000;

      // TODO 각 스캔 타입마다 필요한 데이터 필드만 설정되어 파라미터로 전달되도록 수정 필요함.
      forEach(['telnetuserId1', 'telnetuserPw1', 'telnetuserId2', 'telnetuserPw2'], (field) => {
        if (has(params, field)) {
          delete params[field];
        }
      });
      const requireEncryptFields = ['community', 'snmpCommunityRead', 'snmpCommunityReadwrite', 'snmpV3AuthPassword', 'snmpV3PrivPassword'];
      if (this.tabName === 'snmp') {
        const encryptTargetData = createEncryptTargetData(params, requireEncryptFields);
        getRsaEncrypt(encryptTargetData)
          .then((encryptData) => {
            this.loadScanData(assign(params, encryptData));
          })
          .catch((e) => {
            this.$message(MsgUtil.getResultMsgData('수행', 'IP 스캔', false));
            throw new Error(e);
          });
      } else {
        forEach(requireEncryptFields, (field) => {
          if (has(params, field)) {
            delete params[field];
          }
        });
        this.loadScanData(params);
      }
    },
    loadScanData(params) {
      IpScanAPI.executeScan(params)
        .then((response) => {
          this.isLoading = false;
          const result = response.data;
          let resultData = this.tabName === 'traceroute' ? null : [];
          if (result.success) {
            resultData = result.data;
          }
          this.$emit('set-table-data', this.tabName === 'traceroute' ? resultData : sortBy(resultData, ['orderbyIndex']));
        })
        .catch(() => {
          this.$emit('set-table-data', this.tabName === 'traceroute' ? null : []);
        })
        .finally(() => {
          this.isLoading = false;
          this.$emit('change-is-loading', false);
        });
    },
    validateIpaddress(rule, value, callback) {
      if (isNil(value) || value === '') {
        callback(new Error('필수 정보입니다'));
      } else if (!validateIpv4(value)) {
        callback(new Error('IP를 확인해주세요'));
      } else {
        callback();
      }
    },
    validatePort(rule, value, callback) {
      if (isNil(value) || value === '') {
        callback(new Error('필수 정보입니다'));
      } else if (validateInteger(value)) {
        callback();
      } else {
        callback(new Error('포트를 확인해주세요'));
      }
    },
    setMinMaxData(name, to, from, min, max) {
      if (isNil(to) || to === '') {
        this.formData[name] = null;
      } else {
        /* eslint-disable no-lonely-if */
        if (!validateInteger(to)) {
          this.formData[name] = from;
        } else if (validateInteger(to)) {
          if (to < min) {
            this.formData[name] = min;
          } else if (to > max) {
            this.formData[name] = max;
          }
        }
        /* eslint-enable no-lonely-if */
      }
    },
    checkEnter() {},
  },
};
</script>

<style scoped>
.el-form-item {
  width: 110px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/IpScan/components/ScanConditionBox.vue